import React, { Component } from 'react';

import Input from '../../../components/UI/CustomInputField';
import WidgetPropTypes from '../types';
import RadioButtonGroup from '../../../components/UI/RadioButtonGroup/index.tsx';
import { fccFlows } from '../../App/constants';

export const WIDGET_NAME = 'set_parental_unit_name';

class ParentName extends Component {
  state = {
    radioSelected: '',
    parentName: '',
    otherName: '',
    error: false,
    otherNameMessage: ''
  };

  onChange = which => value => {
    this.setState({ [which]: value });
  };

  componentDidMount() {
    const { widget, changeAnswerValue } = this.props;

    // For FCC flow we want to default this to parent and hide from the UI

    if (fccFlows.indexOf(this.props.app.flowId) !== -1) {
      this.setState({ otherName: 'Parent' });
      changeAnswerValue(widget, 'Parent');
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { widget, shouldEnable } = this.props;
    if (
      this.state.radioSelected !== prevState.radioSelected ||
      this.state.otherName !== prevState.otherName
    ) {
      if (
        this.state.radioSelected === 'mom' ||
        this.state.radioSelected === 'dad' ||
        (this.state.radioSelected === 'other' && this.state.otherName)
      ) {
        shouldEnable(widget, true);
      } else {
        shouldEnable(widget, false);
      }
    }

    if (
      fccFlows.indexOf(this.props.app.flowId) !== -1 &&
      this.state.otherName !== prevState.otherName
    ) {
      shouldEnable(widget, true);
    }
  }

  handleRadioChange = changeEvent => {
    const { widget, changeAnswerValue } = this.props;
    changeAnswerValue(widget, changeEvent.target.value);
    this.setState({
      radioSelected: changeEvent.target.value
    });
  };

  render() {
    const { widget, changeAnswerValue } = this.props;

    if (fccFlows.indexOf(this.props.app.flowId) !== -1) {
      return null;
    }

    return (
      <div>
        <p style={{ textAlign: 'left', fontWeight: '500', fontSize: '18px' }}>
          What do the kids call you?
        </p>
        <RadioButtonGroup
          radioButtons={[
            { value: 'dad', label: 'Dad', 'data-e2e': 'dad' },
            { value: 'mom', label: 'Mom', 'data-e2e': 'mom' },
            { value: 'other', label: 'Other', 'data-e2e': 'other' }
          ]}
          selected={this.state.radioSelected}
          onClick={this.props.onClick}
          onChange={this.handleRadioChange}
        />
        {this.state.radioSelected === 'other' && (
          <Input
            id="other-name"
            style={{ marginTop: '45px' }}
            placeholder="Other name"
            autoComplete="off"
            autoCorrect="off"
            type="text"
            onClick={this.props.onClick}
            error={this.state.otherNameError}
            format={this.state.otherNameMessage}
            disabled={this.state.radioSelected !== 'Other'}
            onChange={value => {
              changeAnswerValue(widget, value);
              this.setState({ otherName: value });
            }}
            className="ParEmailReg-Other-Name"
            value={this.state.otherName}
            data-e2e="other-name"
          />
        )}
      </div>
    );
  }
}

ParentName.propTypes = {
  changeAnswerValue: WidgetPropTypes.changeAnswerValue.isRequired,
  onClick: WidgetPropTypes.onClick.isRequired,
  shouldEnable: WidgetPropTypes.shouldEnable.isRequired,
  widget: WidgetPropTypes.widget.isRequired
};

export default ParentName;
